function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var XS_PHONE_BREAK_POINT = 320;
var PHONE_BREAK_POINT = 480;
var TABLET_BREAK_POINT = 768;
var DESKTOP_BREAK_POINT = 1024;
var WIDESCREEN_BREAK_POINT = 1366;
var WIDESCREEN_MD_BREAK_POINT = 1440;
var WIDESCREEN_LG_BREAK_POINT = 1800;
function testimonials() {
  jQuery(document).ready(function () {
    var $container = jQuery('.section-testimonials-container').first();
    if ($container.length === 0) {
      return;
    }
    var slider = new TestimonialSlider($container);
    var optionText = jQuery('.testimonial-switch-option.active').text();
    jQuery('.testimonial-switch-slider').text(optionText);
    jQuery('.testimonial-switch-option').click(function () {
      if (!jQuery(this).hasClass('active')) {
        jQuery('.testimonial-switch-option.active').removeClass('active');
        jQuery(this).addClass('active');
        var optionText = jQuery(this).text();
        refreshSwitchSlider();
        var category_name = optionText.toLowerCase().replace(' ', '-');
        jQuery('.section-testimonials-row').hide();
        jQuery('.section-testimonials-row').removeClass('active');
        jQuery('.row-category-' + category_name).show();
        jQuery('.row-category-' + category_name).addClass('active');

        // Set slider
        slider.setActiveRow(parseInt(jQuery(this).attr('data-row-index')));
      }
    });
    jQuery(window).resize(function () {
      refreshSwitchSlider();
    });
  });
  function refreshSwitchSlider() {
    var activeTestimonialSwitchOption = jQuery('.testimonial-switch-option.active');
    if (activeTestimonialSwitchOption.length) {
      var leftPos = activeTestimonialSwitchOption.position().left;
      var optionText = activeTestimonialSwitchOption.text();
      jQuery('.testimonial-switch-slider').css('transform', 'translateX(' + (leftPos - 5) + 'px)');
      jQuery('.testimonial-switch-slider').text(optionText);
    }
  }
}
var TestimonialSlider = /*#__PURE__*/function () {
  function TestimonialSlider(container) {
    _classCallCheck(this, TestimonialSlider);
    this.rowElements = [];
    this.activeRow = 0;
    this.registerElements(container);
    this.setRowWidth();
    this.setTestimonialsWidth();
    this.registerButtonEvents();
    this.refreshButtons();
    jQuery(window).resize(this.refresh.bind(this));
  }
  return _createClass(TestimonialSlider, [{
    key: "refresh",
    value: function refresh() {
      this.setRowWidth();
      this.setTestimonialsWidth();
      this.refreshButtons();
    }
  }, {
    key: "registerElements",
    value: function registerElements(container) {
      this.container = container;
      this.rowContainerList = container.find(".section-testimonials-row-container");
      var _iterator = _createForOfIteratorHelper(this.rowContainerList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;
          var rowContainer = jQuery(el);
          this.rowElements.push({
            row: rowContainer.find('.section-testimonials-row'),
            testimonials: rowContainer.find('.section-testimonials__testimonial'),
            testimonialsCount: rowContainer.find('.section-testimonials__testimonial').length,
            currentPosition: 0
          });
          this.buttonLeft = this.container.find('#testimonials-carousel-button-left'), this.buttonRight = this.container.find('#testimonials-carousel-button-right');
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "setRowWidth",
    value: function setRowWidth() {
      var _this = this;
      this.rowElements.forEach(function (rowObj) {
        var windowWidth = jQuery(window).width();
        if (windowWidth < TABLET_BREAK_POINT) {
          _this.calculateRowWidth(rowObj, 1.2);
        } else if (windowWidth < DESKTOP_BREAK_POINT) {
          _this.calculateRowWidth(rowObj, 1.5);
        } else {
          _this.calculateRowWidth(rowObj, 3);
        }
      });
    }
  }, {
    key: "calculateRowWidth",
    value: function calculateRowWidth(rowObj, testimonialsPerRow) {
      rowObj.row.css('min-width', "".concat(Math.round(100 / testimonialsPerRow * rowObj.testimonialsCount * 100) / 100, "%"));
    }
  }, {
    key: "setTestimonialsWidth",
    value: function setTestimonialsWidth() {
      this.rowElements.forEach(function (rowObj) {
        var wPercent = Math.round(100 / rowObj.testimonialsCount * 100) / 100;
        rowObj.testimonials.css('width', "".concat(wPercent, "%")).css('opacity', '1');

        // Breite nur messen, wenn die Row sichtbar ist
        if (rowObj.row.is(':visible')) {
          rowObj.testimonialWidth = rowObj.testimonials.first().outerWidth(true);
        }
      });
    }
  }, {
    key: "registerButtonEvents",
    value: function registerButtonEvents() {
      if (this.buttonLeft) {
        this.buttonLeft.click(this.onButtonLeftClick.bind(this));
      }
      if (this.buttonRight) {
        this.buttonRight.click(this.onButtonRightClick.bind(this));
      }
    }
  }, {
    key: "onButtonLeftClick",
    value: function onButtonLeftClick() {
      var rowObj = this.rowElements[this.activeRow];
      if (rowObj.currentPosition > 0) rowObj.currentPosition--;
      rowObj.row.css('transform', "translate(-".concat(rowObj.testimonialWidth * rowObj.currentPosition, "px, 0px)"));
      this.refreshButtons();
    }
  }, {
    key: "onButtonRightClick",
    value: function onButtonRightClick() {
      var rowObj = this.rowElements[this.activeRow];
      var visible = this.getVisibleCount();
      if (rowObj.currentPosition < rowObj.testimonialsCount - visible) rowObj.currentPosition++;
      rowObj.row.css('transform', "translate(-".concat(rowObj.testimonialWidth * rowObj.currentPosition, "px, 0px)"));
      this.refreshButtons();
    }
  }, {
    key: "refreshButtons",
    value: function refreshButtons() {
      var rowObj = this.rowElements[this.activeRow];
      var visible = this.getVisibleCount();
      if (rowObj.testimonialsCount <= visible) {
        this.hideLeftButton();
        this.hideRightButton();
      } else {
        this.showLeftButton();
        this.showRightButton();
        if (rowObj.currentPosition <= 0) this.hideLeftButton();
        if (rowObj.currentPosition >= rowObj.testimonialsCount - visible) this.hideRightButton();
      }

      // Optional: Sicherheitsabschaltung bei extrem breiten Viewports
      if (jQuery(window).width() > 500 * rowObj.testimonialsCount + 400) {
        this.hideLeftButton();
        this.hideRightButton();
      }
    }
  }, {
    key: "hideLeftButton",
    value: function hideLeftButton() {
      this.buttonLeft.css('opacity', '0');
      this.buttonLeft.css('pointer-events', 'none');
    }
  }, {
    key: "showLeftButton",
    value: function showLeftButton() {
      this.buttonLeft.css('opacity', '1');
      this.buttonLeft.css('pointer-events', 'auto');
    }
  }, {
    key: "hideRightButton",
    value: function hideRightButton() {
      this.buttonRight.css('opacity', '0');
      this.buttonRight.css('pointer-events', 'none');
    }
  }, {
    key: "showRightButton",
    value: function showRightButton() {
      this.buttonRight.css('opacity', '1');
      this.buttonRight.css('pointer-events', 'auto');
    }
  }, {
    key: "setActiveRow",
    value: function setActiveRow(rowIndex) {
      this.activeRow = rowIndex;
      var rowObj = this.rowElements[this.activeRow];

      // Position zurücksetzen
      rowObj.currentPosition = 0;
      rowObj.row.css('transform', 'translate(0px, 0px)');

      // Jetzt ist die Row sichtbar → Breite messen, falls (noch) nicht vorhanden
      if (!rowObj.testimonialWidth || rowObj.testimonialWidth === 0) {
        rowObj.testimonialWidth = rowObj.testimonials.first().outerWidth(true);
      }
      this.refreshButtons();
    }
  }, {
    key: "getVisibleCount",
    value: function getVisibleCount() {
      var w = jQuery(window).width();
      if (w < TABLET_BREAK_POINT) return 1; // ~1 Karte sichtbar
      if (w < DESKTOP_BREAK_POINT) return 2; // ~2 Karten sichtbar
      return 3; // Desktop
    }
  }]);
}();
export default testimonials;